// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qEE8","content":"styles_content__2f_JI"};